export default function ProductSkeleton() {
  return (
    <div className="col-md-4 col-lg-3 mb-4">
      <div className="card placeholder-glow h-100">
        <div className="card-body">
          <span className="placeholder col-6"></span>
          <span className="placeholder col-4"></span>
          <span className="placeholder col-8"></span>
        </div>
      </div>
    </div>
  );
}
